import { WarningCircle } from "@phosphor-icons/react";

export function NoFiscalNotice({ className = "" }) {
  return (
    <div className={`flex items-start gap-2 rounded-lg border border-amber-300 bg-amber-50 px-3 py-2 text-xs text-amber-900 ${className}`}
      data-testid="no-fiscal-notice">
      <WarningCircle size={16} weight="fill" className="mt-0.5 shrink-0 text-amber-600" />
      <span><b>Documento sem valor fiscal.</b> Até à certificação pela DNRE, o GESTA CV emite apenas orçamentos,
        pró-formas e recibos internos.</span>
    </div>
  );
}
